import * as React from "react";
import { cn } from "@/lib/utils";

export interface ButtonGroupProps extends React.HTMLAttributes<HTMLDivElement> {}

const ButtonGroup = React.forwardRef<HTMLDivElement, ButtonGroupProps>(
  ({ className, ...props }, ref) => {
    return (
      // biome-ignore lint/a11y/useSemanticElements: div with role="group" is correct ARIA pattern for button groups
      <div ref={ref} className={cn("inline-flex rounded-md", className)} role="group" {...props} />
    );
  }
);
ButtonGroup.displayName = "ButtonGroup";

export { ButtonGroup };
